let _api, _location, _state, _q, _analytics, _window;

const _ = require('lodash'), angular = require('angular'), $ = require('jquery'), UrlInfo = require('../../olycommon/urlinfo/url-info');

const cache = {};

const pushGtm = function (data, state) {
    if (state && state.current && state.current.name === 'root') {
        data = $(document).attr('title');
    }
    _analytics.push({ data, type: _analytics.mapperTypes.seo.pageTitle });
};

function constructCanonicalUrl(canonicalUrl) {
    switch (_state.current.name) {
        case 'shop.recipes.category':
            return `${_window.location.origin}/shop/recipes/${_state.params.category}`;
        case 'shop.recipes.category.subCategory':
            return `${_window.location.origin}/shop/recipes/${_state.params.category}/${_state.params.subCategory}`;
        default:
            return canonicalUrl;
    }
}

function parseCanonical(canonical) {
    if (!_state.current.name.startsWith('shop.recipes.category')) {
        return canonical;
    }

    const match = canonical.toLowerCase().match(/(pagenumber=[0-9]+)/);
    const canonicalUrl = constructCanonicalUrl(canonical);

    if (!match) {
        return canonicalUrl;
    }

    return `${canonicalUrl}?${match[0]}`;
}

function PageMetadata(restangular, $location, $state, $q, $window, analytics) {
    _api = restangular.one('SeoMetatags');
    _location = $location;
    _state = $state;
    _q = $q;
    _window = $window;
    _analytics = analytics;
}

PageMetadata.prototype.defaultMetadata = {
    title: '',
    metaDescription: '',
    metaRobot: '',
    meta404: '',
    metaPrevUrl: '',
    metaNextUrl: '',
    sessionGroups: null,
    openGraph: {
        image: '',
        imageWidth: '',
        imageHeight: '',
    },
    canonical: null,
};

function normalize(metaData) {
    const title = metaData.Title || metaData.title || '';
    const metaDescription = metaData.MetaDescription || metaData.metaDescription || '';
    const metaRobot = metaData.MetaRobot || metaData.metaRobot || null;
    const meta404 = metaData.meta404 || null;
    const sessionGroups = metaData.sessionGroups || metaData.Groups || null;
    const openGraph = metaData.openGraph || { image: '' };
    const canonical = parseCanonical(metaData.canonical) || null;
    pushGtm(title, _state);

    return {
        title,
        metaDescription,
        metaRobot,
        meta404,
        metaPrevUrl: metaData.metaPrevUrl,
        metaNextUrl: metaData.metaNextUrl,
        sessionGroups,
        openGraph,
        canonical,
    };
}

PageMetadata.prototype.controlSeries = function (currentPage, totalPages) {
    const currentUrl = _location.url();
    const urlInfo = new UrlInfo(currentUrl);

    // if current pageNumber 1, do not show prev
    if (currentPage === 1) {
        // don't show previous
        this.metaPrevUrl = '';
    } else {
        // show previous
        const prevPage = currentPage - 1;
        urlInfo.search({ pageNumber: prevPage }, true);
        this.metaPrevUrl = urlInfo.href();
    }

    // if current page is last page, do not show next
    if (currentPage === totalPages) {
        // don't show next
        this.metaNextUrl = '';
    } else {
        const nextPage = currentPage + 1;
        urlInfo.search({ pageNumber: nextPage }, true);
        this.metaNextUrl = urlInfo.href();
    }
};

/**
 * Sets metadata for robot meta tag
 * @param {bool} isIndex - if page is indexed, set null or undefined if dont care.
 * @param {bool} isFollow - if page is followed, set null or undefined if dont care.
 */
PageMetadata.prototype.setMetaRobot = function (isIndex, isFollow) {
    const metaRobot = [];

    if (isIndex !== undefined && isIndex !== null) {
        metaRobot.push(isIndex ? 'index' : 'noindex');
    }

    if (isFollow !== undefined && isFollow !== null) {
        metaRobot.push(isFollow ? 'follow' : 'nofollow');
    }

    if (metaRobot.length) {
        return metaRobot.join(', ');
    }

    return '';
};

/**
 * Sets metadata for robot meta tag, handles whether the currentPage is greater than 2
 * @param {Object} currentPage - The current page for the list you're on
 */
PageMetadata.prototype.setMetaRobotOnPageChange = function (currentPage, updateMetadata) {
    if (_state.current.name.startsWith('shop.recipes.category')) {
        this.metaRobot = null;
    } else if (currentPage && currentPage > 1) {
        this.metaRobot = updateMetadata ? this.setMetaRobot(false, true) : null;
    }
};

/**
 * Gets metadata from the server which has been set up in site management.
 * @param {Object} formatObject - The format object contains key/value pairs which can be used in
 *  the format string which is set up in site management
 * @param {boolean} [isSpecial] - If this is true, will only search for metadata created for
 *  specials pages.
 * @param {String} urlPath - This is the key which metadata is created against and which will be
 *  used to search for the metadata.
 * @param {String} [pageType] - This is used to search for metadata from only one of these categories:
 *  Department, Aisle, LandingPage, Product, Recipe, FreeText, RecipeCategory, Home.
 * @param {Object} extraMetadata - Key/value pairs to merge into the metadata result returned from
 *  the server (e.g. opengraph metadata).
 * @returns {Promise}
 */
PageMetadata.prototype.getMetadata = function (formatObject, isSpecial, urlPath, pageType, extraMetadata) {
    const path = urlPath || _location.path();
    const special = isSpecial || false;
    const key = `${path}-${special}-${pageType}`;
    // reset this variable to remove <meta name="robot" value="noindex, follow"> when navigating to a different list
    return key in cache
        ? _q.when(cache[key])
        : _api.doPOST({
            UrlPath: path,
            IsSpecial: special,
            FormatObject: JSON.stringify((formatObject || {})),
            PageType: pageType,
        })
            .then(metaResponse => _.assign(metaResponse, extraMetadata))
            .then(normalize.bind(this))
            .then((result) => {
                cache[key] = result;
                window.prerenderReady = true;
                return result;
            });
};

PageMetadata.prototype.getCurrentMetadata = function () {
    return {
        title: this.title,
        metaDescription: this.metaDescription,
        metaRobot: this.metaRobot,
        meta404: this.meta404,
        metaPrevUrl: this.metaPrevUrl,
        metaNextUrl: this.metaNextUrl,
        sessionGroups: this.sessionGroups,
        openGraph: this.openGraph,
    };
};

PageMetadata.prototype.setMetadata = function (metaData) {
    if (!metaData) {
        return;
    }

    if (angular.isFunction(metaData.then)) {
        metaData.then(this.setMetadata.bind(this));
    } else {
        _.assign(this, normalize.call(this, metaData));
    }
};

PageMetadata.prototype.useCurrentStateMetadata = function () {
    if (_state.shouldGetMetaData()) {
        this.setMetadata(_state.getMetadata());
    }
};

module.exports = PageMetadata;



// WEBPACK FOOTER //
// ./src/common/pagemetadata/page-metadata.service.js